const ROUTE_INTERNAL = 'int';
const ROUTE_EXTERNAL = 'ext';

// Read inline, not destructured at import time: webpack inlines these at
// build time in the real app, but under `react-scripts test` they are plain
// runtime env vars a test sets in its own beforeEach.
const internalTenantId = () => process.env.REACT_APP_INTERNAL_USERS_TENANT_ID;
const externalTenantId = () => process.env.REACT_APP_EXTERNAL_USERS_TENANT_ID;

const routeForTenantId = tenantId =>
  tenantId === externalTenantId() ? ROUTE_EXTERNAL : ROUTE_INTERNAL;

const tenantIdForRoute = route =>
  route === ROUTE_EXTERNAL ? externalTenantId() : internalTenantId();

// Given /resolveTenant's answer for the Google-verified email, says which
// route Google may sign into — or null to refuse, before Firebase is told
// anything. INT always wins even from `/ext`; EXT only proceeds if the
// pathname already agreed; anything else blocks with no pathname fallback.
export function decideGoogleRoute(route, pathnameRoute) {
  if (route === ROUTE_INTERNAL) {
    return ROUTE_INTERNAL;
  }
  if (route === ROUTE_EXTERNAL && pathnameRoute === ROUTE_EXTERNAL) {
    return ROUTE_EXTERNAL;
  }
  return null;
}

// Decides the tenant a Google sign-in may use, from the real email GIS
// handed back — never the typed login field, which the chooser can leave
// stale. Firebase is never touched here.
export async function resolveGoogleTenant({ email, tenantID, resolveTenant }) {
  const route = await resolveTenant(email);
  const decided = decideGoogleRoute(route, routeForTenantId(tenantID));
  // Fails closed on a misconfigured deploy too: a decided route whose tenant
  // id env var is missing/empty must never reach signInWithCredential with
  // auth.tenantId left undefined, which would sign into the project's whole
  // user pool instead of either tenant.
  const resolvedTenantId = decided ? tenantIdForRoute(decided) : null;
  return resolvedTenantId ? { tenantId: resolvedTenantId } : { blocked: true };
}
